export default __webpack_public_path__ + "static/media/playStore.68b0b4ca.png";